import MaterialStepLabel, { StepLabelProps } from '@mui/material/StepLabel';

function StepLabel(props: StepLabelProps) {
    return <MaterialStepLabel data-testid={'StepLabel-container'} {...props} />;
}

export default StepLabel;
